import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  //주요 component 별로 나눠 state의 초기값을 넣어주세요.
  //cemsSlice 참조 './cemsSlice'
};

export const tispSlice = createSlice({
  name: "tisp",
  initialState,
  reducers: {
    //위의 initialState 안에 있는 state값을 변경 시키는 함수, action
  },
});

// 위에서 등록한 action(예시에선 increment, decrement, incrementByAmount)등을 모두 밑에 넣어주시면 등록됩니다.
export const { changeBaseService } = tispSlice.actions;

export default tispSlice.reducer;
